import { TokensBaseURL } from '@src/libs/api'
import { ITokenInfoResponse } from '@src/types/tokenInfo'
import { createContextLogger } from '@src/utils/logger'

const logger = createContextLogger('AssetV2API')

export const apiGetTokenInfo = async (chainName: string, address: string): Promise<ITokenInfoResponse | null> => {
    try {
        // Always use v1 API URL for token info endpoint
        const { data } = await TokensBaseURL.get<ITokenInfoResponse>(
            `v1/tokens/token_info?chain=${chainName.toLowerCase()}&token_address=${address}`
        )
        return data
    } catch (error) {
        logger.error(`Error fetching token info for ${address} on ${chainName}:`, error)
        return null
    }
}
